import { useEffect, useState, useRef } from 'react';

import { Button, Frame, LevelManager, Timer, Points, ClickCount, Title, SubTitle } from '../Components';

import { games } from '../Config/config';

const Game = ({ game, setScreen, setScore }) => {
    const scaleWidth = 1350;

    const frame = useRef();
    const [points, setPoints] = useState(0);
    const [clicks, setClicks] = useState(0);
    const [scale, setScale] = useState(1);
    const [level, setLevel] = useState(1);
    const [running, setRunning] = useState(true);
    const [timer, setTimer] = useState(30);

    const isLastLevel = Object.values(games[game]).length === level;

    useEffect(() => {
        const calculateScale = () => setScale(frame.current.clientWidth / scaleWidth);

        window.addEventListener('resize', calculateScale);

        calculateScale();

        return () => {
            window.removeEventListener('resize', calculateScale);
        };
    }, []);

    const reduceTime = (reduction) => {
        if (running) {
            setTimer(timer => {
                if (timer - reduction < 0) {
                    return 0;
                }

                return timer - reduction;
            })
        }
    };

    const reducePoints = (reduction) => {
        if (running) {
            setPoints(points => {
                if (points - reduction < 0) {
                    return 0;
                }

                return points - reduction;
            });
        }
    };

    const increasePoints = (addition) => {
        if (running) {
            setPoints(points => points + addition);
        }
    };

    const handleGameShouldStop = () => {
        setTimeout(() => {
            setRunning(false);
        }, 1000);
    };

    const handleNextLevel = () => {
        setLevel(level => level + 1);
        setRunning(true);
        // setClicks(0);
    };

    const handleClick = ({ target }) => {
        if (running) {
            setClicks(clicks => clicks + 1);

            if (!target.classList.contains('target')) {
                reducePoints(5);
                reduceTime(2);
            }
        }
    };

    const updateTimer = (update) => {
        if (running) {
            setTimer(update);
        }
    };

    const handleFinishGame = (failed = false) => {
        if (failed) {
            setScore(0);
        } else {
            setScore(timer);
        }

        setScreen('game-over');
    };

    return (
        <div className="w-full h-full flex justify-center items-center" onClick={handleClick}>
            <Frame ref={frame}>
                {!running && (
                    <div className="flex flex-col w-full text-center absolute -top-5 lg:-top-16 z-20">
                        <Title>Well Played!</Title>
                        <SubTitle>Your results</SubTitle>
                    </div>
                )}

                <LevelManager
                    key={`${game}-${level}-level-manager`}
                    scale={scale}
                    game={game}
                    level={level}
                    increasePoints={increasePoints}
                    running={running}
                    handleGameShouldStop={handleGameShouldStop}
                />

                {!running && (
                    <>
                        {isLastLevel ? (
                            <Button
                                className="-left-16 lg:-left-24 bottom-4 lg:bottom-10 absolute"
                                size="small"
                                onClick={() => handleFinishGame(false)}
                            >
                                Finish Game
                            </Button>
                        ) : (
                            <Button
                                className="-left-16 lg:-left-24 bottom-4 lg:bottom-10 absolute"
                                size="small"
                                onClick={() => handleNextLevel()}
                            >
                                Next Level
                            </Button>
                        )}
                    </>
                )}

                <div className="flex flex-col justify-center gap-1 lg:gap-10 h-full absolute top-0 bottom-0 -right-12 lg:-right-24">
                    <Timer
                        key={`${game}-${level}-timer`}
                        time={timer}
                        running={running}
                        onComplete={() => handleFinishGame(true)}
                        onUpdate={updateTimer}
                    />

                    {/*<Points*/}
                    {/*    points={points}*/}
                    {/*/>*/}

                    <ClickCount
                        onComplete={() => handleFinishGame(true)}
                        clicks={clicks}
                    />
                </div>
            </Frame>
        </div>
    );
};

export default Game;
